function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import providerEvents from 'wix-art-store-3rd-party/dist/src/sdk/providerEvents';
import React, { Component } from 'react';
import { providerIntents, ARTSTORE_PUBSUB_ENUMS } from '../consts';
import ProviderIntent from '../components/ProviderIntent';
import WixSDKProviderApi from '../components/WixSDKProviderApi';
import { Wix, window } from '@wix/photography-client-lib';
var BannerIntent = /*#__PURE__*/function (_Component) {
  function BannerIntent(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      styleParams: null,
      connectedProviders: window.connectedProviders
    };
    Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, function (sp) {
      var styleParams = Object.assign({}, sp.numbers, sp.booleans, sp.colors, sp.fonts);
      styleParams.bgColorExpand = styleParams.bgColorExpand || {};
      styleParams.bgColorExpand.value = 'transparent'; // super hack B2C uses the '.shop-background' css class, instead of using transparent
      _this.setState({
        styleParams: styleParams
      });
    });
    return _this;
  }
  _inheritsLoose(BannerIntent, _Component);
  var _proto = BannerIntent.prototype;
  _proto.onMessageReceived = function onMessageReceived(type, payload) {
    switch (type) {
      case providerEvents.setHeight:
        this.props.enableStoreBanner(payload.height && payload.height > 0);
        break;
      default:
        break;
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$state = this.state,
      styleParams = _this$state.styleParams,
      connectedProviders = _this$state.connectedProviders;
    if (styleParams) {
      return /*#__PURE__*/React.createElement(ProviderIntent, {
        api: new WixSDKProviderApi(Wix),
        intent: providerIntents.banner,
        connectedProviders: connectedProviders,
        additionalParams: {
          galleryId: window.galleryId
        },
        onMessageReceived: function onMessageReceived(type, payload, resolve, reject) {
          return _this2.onMessageReceived(type, payload, resolve, reject);
        },
        styleParams: styleParams
      });
    }
    return null;
  };
  return BannerIntent;
}(Component);
export { BannerIntent as default };